import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import useValidation from '../../../hooks/Validation/useValidation'
import { ROUTES } from '../../../shared/constants'
import CustomButton from '../../CustomButton'
import AuthInputField from '../../AuthInputField'
import CustomLabel from '../../CustomLabel'

import countries from '../../../utils/country.json'

const useStyles = makeStyles((theme) => ({
  marginTop: {
    [theme.breakpoints.up('md')]: {
      //
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '25px',
    },
  },
  label: {
    color: 'black',
    fontSize: '12px',
    lineHeight: '20px',
    paddingLeft: '20px',
  },
  loginOption: {
    position: 'relative',
    bottom: '-20px',
    // margin: '0px 54px',
    display: 'flex',
    paddingLeft: '30px',
  },
  link: {
    color: '#32499F',
    cursor: 'pointer',
    marginLeft: '3px',
    paddingLeft: '0px',
    '&:hover': { textDecoration: 'underline' },
  },
  label2: { color: theme.palette.primary.main, fontWeight: 'bold', marginTop: '60px' },
}))
countries.sort(function (a, b) {
  var nameA = a.name.toUpperCase() // ignore upper and lowercase
  var nameB = b.name.toUpperCase() // ignore upper and lowercase
  if (nameA < nameB) {
    return -1
  }
  if (nameA > nameB) {
    return 1
  }

  // names must be equal
  return 0
})

export default function SignupForm({ handleNext, signupData }) {
  const classes = useStyles()
  const history = useHistory()
  const { companyName, setCompanyName, domain, setDomain, country, setCountry, totalEmployees, setTotalEmployees } =
    signupData

  const { error, handleValidation } = useValidation()

  const disableButton = companyName && domain && country && totalEmployees ? false : true

  return (
    <form>
      <AuthInputField
        placeholder="Company Name"
        className={classes.marginTop}
        onKeyDown={() => handleValidation('companyName', companyName)}
        errorMessage={error && error.companyName}
        handleChange={setCompanyName}
        value={companyName}
      />

      <AuthInputField
        placeholder="Country"
        onKeyDown={() => handleValidation('country', country)}
        className={classes.marginTop}
        errorMessage={error && error.country}
        handleChange={setCountry}
        value={country}
        select
        options={countries}
      />
      <AuthInputField
        placeholder="Number of Employees"
        onKeyDown={() => handleValidation('totalEmployees', totalEmployees)}
        className={classes.marginTop}
        errorMessage={error && error.totalEmployees}
        handleChange={setTotalEmployees}
        // type="number"
        number
        value={totalEmployees}
      />
      <Box>
        <Box width="70%" display="flex">
          <AuthInputField
            placeholder="Your Domain"
            onKeyDown={() => handleValidation('domain', domain)}
            className={classes.marginTop}
            errorMessage={error && error.domain}
            handleChange={setDomain}
            value={domain}
          />
          <div>
            <CustomLabel label=".nural.app" className={classes.label2} />
          </div>
        </Box>
        {/* <Box></Box> */}
      </Box>
      <CustomButton text="NEXT" className={classes.marginTop} handleSubmit={handleNext} disabled={disableButton} />
      <Box display="flex" className={classes.loginOption}>
        <CustomLabel label="Already have an account ?" className={classes.label} />
        <div className={`${classes.label} ${classes.link}`} onClick={() => history.push(ROUTES.HOME)}>
          Login Here
        </div>
      </Box>
    </form>
  )
}
